import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';

const Board = () => {

  const user = auth.currentUser;  //Récupérer les données de l'utilisateur
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const q = query(collection(db, "users"),
        where("email", "==", user.email))
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUserRole(doc.data()?.role);
      })
    };
    fetchUserData();
  }, [user]);

  const [articlesCount, setArticlesCount] = useState(null);
  const [projects, setProjects] = useState(null);
  const [users, setUsers] = useState(null);
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    //articles
    const a = query(collection(db, "articles"), where('isVisible', '==', true));
    getDocs(a)
      .then((querySnapshot) => {
        const count = querySnapshot.size;
        setArticlesCount(count);
      })
      .catch((error) => {
      });

    //projects
    const c = query(collection(db, "projects"), where('isVisible', '==', true));
    getDocs(c)
      .then((querySnapshot) => {
        const count = querySnapshot.size;
        setProjects(count);
      })
      .catch((error) => {
      });

    //users
    const k = query(collection(db, "users"));
    getDocs(k)
      .then((querySnapshot) => {
        const count = querySnapshot.size;
        setUsers(count);
      })
      .catch((error) => {
      });

    //jobs
    const r = query(collection(db, "team"), where('isVisible', '==', true));
    getDocs(r)
      .then((querySnapshot) => {
        const count = querySnapshot.size;
        setJobs(count);
      })
      .catch((error) => {
      });

  }, []);

  return (
    <div className='flex items-center justify-center gap-20 w-full p-[60px]'>

      <section className="grid xl:grid-cols-3 grid-cols-1 gap-5 text-white font-agrandir">

        <Link to={'/dashboard/blogapp'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-aqua border-2 rounded-lg shadow-md' id='articles_count'>
          {articlesCount !== null ? (
            <p className='text-[32px] font-bold'>{articlesCount}</p>
          ) : (
            <p className='text-[32px] font-bold'>...</p>
          )}
          <p className='text-[18px]'>Article.s publié.s</p>
        </Link>

        <Link to={'/dashboard/projectapp'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-black border-2 rounded-lg shadow-md' id='collections_count'>
          {projects !== null ? (
            <p className='text-[32px] font-bold'>{projects}</p>
          ) : (
            <p className='text-[32px] font-bold'>...</p>
          )}
          <p className='text-[18px]'>Project.s</p>
        </Link>

        {/*<Link to={'/dashboard/inbox'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-black rounded-lg shadow-md' id='rubriques_count'>
          {unreadMessages !== null ? (
            <p className='text-[32px] font-bold'>{unreadMessages}</p>
          ) : (
            <p className='text-[32px] font-bold'>...</p>
          )}
          <p className='text-[18px]'>Message.s non lu.s</p>
        </Link>

        <Link to={'/dashboard/docs'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-black rounded-lg shadow-md' id='members_count'>
          {docs !== null ? (
            <p className='text-[32px] font-bold'>{docs}</p>
          ) : (
            <p className='text-[32px] font-bold'>...</p>
          )}
          <p className='text-[18px]'>Document.s</p>
        </Link> */}

        {userRole === 'Administrateur' &&
          <Link to={'/dashboard/users'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-black border-2 rounded-lg shadow-md' id='collections_count'>
            {users !== null ? (
              <p className='text-[32px] font-bold'>{users}</p>
            ) : (
              <p className='text-[32px] font-bold'>...</p>
            )}
            <p className='text-[18px]'>Utilisateurs.s</p>
          </Link>
        }

        <Link to={'/dashboard/team'} className='flex flex-col justify-center items-center p-[30px] gap-5 bg-black border-2 rounded-lg shadow-md' id='rubriques_count'>
          {jobs !== null ? (
            <p className='text-[32px] font-bold'>{jobs}</p>
          ) : (
            <p className='text-[32px] font-bold'>...</p>
          )}
          <p className='text-[18px]'>Team</p>
        </Link>

      </section>

    </div>
  )
}

export default Board